import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import QuantitySelector from "../components/QuantitySelector";
import {
  increaseQuantity,
  decreaseQuantity,
  removeFromCart,
} from "../redux/store/cartSlice";
import { IoMdClose } from "react-icons/io";
import api from "../utilis/api";
import { toast } from "react-toastify";
const Payment = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [order, setOrder] = useState({});
  const { token, user } = useSelector((state) => state.user);
  const { name } = location.state;
  const handlePayment = () => {
    if (isLoading || isSuccess) return;

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      setIsSuccess(true);
    }, 4000);
  };

  const dispatch = useDispatch();
  const { cartItems, totalPrice, quantity } = useSelector(
    (state) => state.cart,
  );
  const payload = { userId: user?._id || "", guestName: name };
  console.log(payload);
  const getOrders = async () => {
    const response = await api.get(
      `/orders/latest?userId=${user?._id || ""}&guestName=${name || ""}`,
    );
    console.log(response);
    if (response.data?.meta?.success) {
      setOrder(response.data?.data.order);
    } else {
      toast.error(response.data?.meta?.message || "Order failed", {
        autoClose: 4000,
      });
    }
  };
  useEffect(() => {
    getOrders();
  }, [token]);

  const subtotalPrice = cartItems.reduce(
    (acc, item) => acc + item.variants?.[0].price * item.quantity,
    0,
  );

  return (
    <>
      <Navbar />
      <div className="bg-white w-full py-[1rem]  px-[1rem] sm:px-[5rem] text-[16px] text-gray-500">
        <span className="text-gray-800">
          {" "}
          <Link to={"/"}>Home</Link>
        </span>{" "}
        {">"} Payment
      </div>
      <div className="flex flex-col justify-center items-start gap-8 py-8 px-4 sm:px-8 md:px-16 lg:px-24 bg-white min-h-[calc(100vh-64px)]">
        {/* Top Section: Payment Form + Order Summary */}
        <div className="flex flex-col lg:flex-row justify-center items-start gap-8 w-full">
          {/* Payment Form */}
          <div className="bg-white w-full lg:w-1/2 p-6 rounded-lg shadow-lg">
            <h1 className="text-2xl font-semibold mb-6">Payment Method</h1>

            <div className="space-y-4 mb-6">
              <input
                type="text"
                placeholder="Card Number"
                className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-black"
              />
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="text"
                  placeholder="MM/YY"
                  className="flex-1 border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-black"
                />
                <input
                  type="text"
                  placeholder="CVC"
                  className="flex-1 border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>
            </div>

            <button
              onClick={handlePayment}
              disabled={isLoading || isSuccess}
              className={`w-full py-3 rounded-md font-semibold transition duration-300
          ${
            isSuccess
              ? "bg-green-600 text-white"
              : isLoading
                ? "bg-red-400 text-white cursor-not-allowed"
                : "bg-red-500 text-white hover:bg-red-700"
          }`}
            >
              {isLoading
                ? "Processing Payment..."
                : isSuccess
                  ? "Payment Successful ✓"
                  : "Pay Now"}
            </button>
          </div>

          {/* Order Summary */}
          <div className="bg-white w-full lg:w-1/2 p-6 rounded-2xl shadow-lg">
            <h2 className="text-2xl font-semibold mb-6">Order Summary</h2>
            <div className="space-y-4">
              <div className="flex justify-between">
                <p>Sub-Total</p>
                <span>${order.itemsPrice && order.itemsPrice.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <p>Delivery</p>
                <span>${order.shippingPrice}</span>
              </div>
              <hr />
              <div className="flex justify-between font-semibold text-lg">
                <p>Total</p>
                <span>
                  ${order?.totalPrice && order?.totalPrice.toFixed(2)}
                </span>
              </div>

              <button
                onClick={handlePayment}
                disabled={isLoading || isSuccess}
                className="w-full bg-red-500 text-white py-3 mt-6 rounded-lg
                   transition-all duration-300 ease-in-out
                   hover:bg-red-700 hover:shadow-lg hover:-translate-y-1
                   active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSuccess ? "Payment Completed" : "Check Out"}
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section: Order Table */}
        <div className="w-full mt-8 overflow-x-auto">
          <table className="w-full border-separate border-spacing-y-4 min-w-[600px]">
            <thead>
              <tr className="text-left text-gray-600 text-sm uppercase tracking-wider">
                <th className="px-4 sm:px-6 py-3 w-[40%]">Products Detail</th>
                <th className="px-4 sm:px-6 py-3 w-[15%] text-center">
                  Quantity
                </th>
                <th className="px-4 sm:px-6 py-3 w-[15%]">Price</th>
                <th className="px-4 sm:px-6 py-3 w-[15%]">Total</th>
                <th className="px-4 sm:px-6 py-3 w-[15%]"></th>
              </tr>
            </thead>
            <tbody>
              {order?.orderItems?.map((data) => (
                <tr
                  key={data.id}
                  className="bg-[#f5f5f5] hover:shadow-md transition-all duration-300 rounded-xl"
                >
                  <td className="px-4 sm:px-6 py-5">
                    <div className="flex items-center gap-4">
                      <img
                        src={data.image}
                        alt={data.name}
                        className="w-16 h-16 object-cover rounded-lg"
                      />
                      <div>
                        <h1 className="font-semibold text-gray-800">
                          {data.name}
                        </h1>
                        <p className="text-sm text-gray-500">{data.vendor}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 sm:px-6 py-5 text-center font-medium">
                    <span>{data.qty}</span>
                  </td>
                  <td className="px-4 sm:px-6 py-5 font-medium text-gray-700">
                    ${data?.price}
                  </td>
                  <td className="px-4 sm:px-6 py-5 font-semibold text-gray-900">
                    ${(data?.price * data.qty).toFixed(2)}
                  </td>
                  {/* <td className="px-4 sm:px-6 py-5 text-center">
                    <button
                      onClick={() => dispatch(removeFromCart(data._id))}
                      className="transition-all duration-300 hover:scale-110"
                    >
                      <IoMdClose className="text-red-500 text-xl hover:text-red-700" />
                    </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Payment;
